import React from 'react'
import { useSelector } from 'react-redux'
import RadioGroupButtons from 'components/RadioGroupButtons/RadioGroupButtons'
import {
  StyledRadioGroupContainer,
  StyledRadioGroupCol,
  StyledMultiSelectionRow,
  StyledMultiSelectionCol,
  StyledMultiSelectionColHeating,
  StyledMultiSelectionRoofCovering,
  StyledMultiSelectionColWindows,
  StyledMultiSelectionColStoreRoom,
  StyledMultiSelectionColFloor,
} from './MapOrReportEquipmentMatrixForm.styled'
import {
  insulatedWalls,
  guestToilet,
  surfaceMountedInstalationEFH,
  heatingType,
  roofCoveringEFHandMFH,
  windowsType,
  storeETW,
  storeMFH,
  floorETW,
  residentialAreaETW,
  residentialAreaMFH,
  bathroomEFH,
  bathroomETW,
} from '../../helper'
import { useTranslation } from 'react-i18next'
import {
  selectAddressFormData,
  setEquipmentDetailsChanged,
  setFormField,
} from 'slices/addressFormSlice'
import { useAppDispatch } from 'store/hooks'
import {
  EquipmentMatrixBathroom,
  EquipmentMatrixFloorCovering,
  EquipmentMatrixHeating,
  EquipmentMatrixResidentialArea,
  EquipmentMatrixRoofCovering,
  EquipmentMatrixStoreRoom,
  EquipmentMatrixSurfaceMountedInstallation,
  EquipmentMatrixWindows,
  ObjectType,
} from 'types/ApiResponse'
import MultiSelect from 'components/MultiSelect/MultiSelect'

function MapOrReportEquipmentMatrixForm() {
  const dispatch = useAppDispatch()
  const addressFormData = useSelector(selectAddressFormData)
  const { t } = useTranslation()

  const onChangeGuestToilet = (guestToilet: boolean) => {
    dispatch(
      setFormField({ key: 'propertyDetails.equipmentMatrix.guestToilet', value: guestToilet })
    )
    dispatch(setEquipmentDetailsChanged(true))
  }

  const onChangeInsulatedWalls = (insulatedExteriorWalls: boolean) => {
    dispatch(
      setFormField({
        key: 'propertyDetails.equipmentMatrix.insulatedExteriorWalls',
        value: insulatedExteriorWalls,
      })
    )
    dispatch(setEquipmentDetailsChanged(true))
  }

  const onChangeSurfaceInstalation = (
    surfaceMountedInstallation: EquipmentMatrixSurfaceMountedInstallation
  ) => {
    dispatch(
      setFormField({
        key: 'propertyDetails.equipmentMatrix.surfaceMountedInstallation',
        value: surfaceMountedInstallation,
      })
    )
    dispatch(setEquipmentDetailsChanged(true))
  }

  const onChangeHeatingChange = (heating: EquipmentMatrixHeating) => {
    dispatch(setFormField({ key: 'propertyDetails.equipmentMatrix.heating', value: heating }))
    dispatch(setEquipmentDetailsChanged(true))
  }

  const onChangeRoofCovering = (roofCovering: EquipmentMatrixRoofCovering) => {
    dispatch(
      setFormField({ key: 'propertyDetails.equipmentMatrix.roofCovering', value: roofCovering })
    )
    dispatch(setEquipmentDetailsChanged(true))
  }

  const onChangeWindows = (windows: EquipmentMatrixWindows) => {
    dispatch(setFormField({ key: 'propertyDetails.equipmentMatrix.windows', value: windows }))
    dispatch(setEquipmentDetailsChanged(true))
  }

  const onStoreRoomChange = (storeRoom: EquipmentMatrixStoreRoom) => {
    dispatch(setFormField({ key: 'propertyDetails.equipmentMatrix.storeRoom', value: storeRoom }))
    dispatch(setEquipmentDetailsChanged(true))
  }

  const onFloorChange = (floorCovering: EquipmentMatrixFloorCovering) => {
    dispatch(
      setFormField({ key: 'propertyDetails.equipmentMatrix.floorCovering', value: floorCovering })
    )
    dispatch(setEquipmentDetailsChanged(true))
  }

  const onChangeOutdoor = (residentialArea: EquipmentMatrixResidentialArea) => {
    dispatch(
      setFormField({
        key: 'propertyDetails.equipmentMatrix.residentialArea',
        value: residentialArea,
      })
    )
    dispatch(setEquipmentDetailsChanged(true))
  }

  const onChangeBathRoom = (bathroom: EquipmentMatrixBathroom) => {
    dispatch(setFormField({ key: 'propertyDetails.equipmentMatrix.bathroom', value: bathroom }))
    dispatch(setEquipmentDetailsChanged(true))
  }

  return (
    <>
      <StyledMultiSelectionRow>
        <StyledMultiSelectionCol>
          <StyledMultiSelectionColHeating>
            <MultiSelect
              options={heatingType}
              onChange={(event) => onChangeHeatingChange(event.target.value)}
              label={`${t('newAddressModal.furnishingTab.heatingOptions.label')}`}
              value={addressFormData.addressData?.propertyDetails?.equipmentMatrix?.heating}
            />
          </StyledMultiSelectionColHeating>
        </StyledMultiSelectionCol>
        {addressFormData.addressData?.propertyDetails?.objectType !== ObjectType.APARTMENT ? (
          <StyledMultiSelectionCol>
            <StyledMultiSelectionRoofCovering>
              <MultiSelect
                options={roofCoveringEFHandMFH}
                onChange={(event) => onChangeRoofCovering(event.target.value)}
                value={addressFormData.addressData?.propertyDetails?.equipmentMatrix?.roofCovering}
                label={`${t('newAddressModal.furnishingTab.roofOptions.label')}`}
              />
            </StyledMultiSelectionRoofCovering>
          </StyledMultiSelectionCol>
        ) : null}
        <StyledMultiSelectionCol>
          <StyledMultiSelectionColWindows>
            <MultiSelect
              options={windowsType}
              onChange={(event) => onChangeWindows(event.target.value)}
              value={addressFormData.addressData?.propertyDetails?.equipmentMatrix?.windows}
              label={`${t('newAddressModal.furnishingTab.windowsOptions.label')}`}
            />
          </StyledMultiSelectionColWindows>
        </StyledMultiSelectionCol>
        {addressFormData.addressData?.propertyDetails?.objectType === ObjectType.APARTMENT ||
        addressFormData.addressData?.propertyDetails?.objectType ===
          ObjectType.MULTI_FAMILY_HOUSE ? (
          <StyledMultiSelectionCol>
            <StyledMultiSelectionColStoreRoom>
              <MultiSelect
                options={
                  addressFormData.addressData?.propertyDetails?.objectType === ObjectType.APARTMENT
                    ? storeETW
                    : storeMFH
                }
                onChange={(event) => onStoreRoomChange(event.target.value)}
                value={addressFormData.addressData?.propertyDetails?.equipmentMatrix?.storeRoom}
                label={`${t('newAddressModal.furnishingTab.storageOptions.label')}`}
              />
            </StyledMultiSelectionColStoreRoom>
          </StyledMultiSelectionCol>
        ) : null}
        {addressFormData.addressData?.propertyDetails?.objectType === ObjectType.APARTMENT ? (
          <StyledMultiSelectionCol>
            <StyledMultiSelectionColFloor>
              <MultiSelect
                options={floorETW}
                onChange={(event) => onFloorChange(event.target.value)}
                value={addressFormData.addressData?.propertyDetails?.equipmentMatrix?.floorCovering}
                label={`${t('newAddressModal.furnishingTab.floorCoveringOptions.label')}`}
              />
            </StyledMultiSelectionColFloor>
          </StyledMultiSelectionCol>
        ) : null}
        {addressFormData.addressData?.propertyDetails?.objectType !== ObjectType.HOUSE ? (
          <StyledMultiSelectionCol>
            <MultiSelect
              options={
                addressFormData.addressData?.propertyDetails?.objectType === ObjectType.APARTMENT
                  ? residentialAreaETW
                  : residentialAreaMFH
              }
              onChange={(event) => onChangeOutdoor(event.target.value)}
              value={addressFormData.addressData?.propertyDetails?.equipmentMatrix?.residentialArea}
              label={`${t('newAddressModal.furnishingTab.outdoorLivingAreaOptions.label')}`}
            />
          </StyledMultiSelectionCol>
        ) : null}
        {addressFormData.addressData?.propertyDetails?.objectType !==
        ObjectType.MULTI_FAMILY_HOUSE ? (
          <StyledMultiSelectionCol>
            <MultiSelect
              options={
                addressFormData.addressData?.propertyDetails?.objectType === ObjectType.HOUSE
                  ? bathroomEFH
                  : bathroomETW
              }
              onChange={(event) => onChangeBathRoom(event.target.value)}
              value={addressFormData.addressData?.propertyDetails?.equipmentMatrix?.bathroom}
              label={`${t('newAddressModal.furnishingTab.bathOptions.label')}`}
            />
          </StyledMultiSelectionCol>
        ) : null}
      </StyledMultiSelectionRow>
      <StyledRadioGroupContainer>
        <StyledRadioGroupCol>
          <RadioGroupButtons
            options={guestToilet}
            label={t('newAddressModal.furnishingTab.separateGuestToilet')}
            onChange={(event) => onChangeGuestToilet(event.target.value)}
            value={addressFormData.addressData?.propertyDetails?.equipmentMatrix?.guestToilet}
          />
        </StyledRadioGroupCol>
        <StyledRadioGroupCol>
          <RadioGroupButtons
            options={insulatedWalls}
            label={t('newAddressModal.furnishingTab.insulatedOuterWalls')}
            onChange={(event) => onChangeInsulatedWalls(event.target.value)}
            value={
              addressFormData.addressData?.propertyDetails?.equipmentMatrix?.insulatedExteriorWalls
            }
          />
        </StyledRadioGroupCol>
        {addressFormData.addressData?.propertyDetails?.objectType === ObjectType.HOUSE ? (
          <StyledRadioGroupCol>
            <RadioGroupButtons
              options={surfaceMountedInstalationEFH}
              label={t('newAddressModal.furnishingTab.linesOnPlaster')}
              onChange={(event) => onChangeSurfaceInstalation(event.target.value)}
              value={
                addressFormData.addressData?.propertyDetails?.equipmentMatrix
                  ?.surfaceMountedInstallation
              }
            />
          </StyledRadioGroupCol>
        ) : null}
      </StyledRadioGroupContainer>
    </>
  )
}

export default MapOrReportEquipmentMatrixForm
